import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AssignmentAvailabilityStatus } from '@wilson/interfaces';
import {
  SetTimelineAssignmentModalFilters,
  ToggleFilterLoading,
} from '@wilson/shift-timeline/state';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TimelineModalFilterService {
  private store = inject(Store);

  private showOnlyQualifiedStaffSubject = new BehaviorSubject(true);
  private showOnlyQualifiedWorkingTimeStaffSubject = new BehaviorSubject(true);
  private staffAvailabilitySubject = new BehaviorSubject(
    AssignmentAvailabilityStatus.Available,
  );

  public showOnlyQualifiedStaff$ =
    this.showOnlyQualifiedStaffSubject.asObservable();

  public displayQualifiedWorkingTimeStaff$ =
    this.showOnlyQualifiedWorkingTimeStaffSubject.asObservable();

  public staffAvailability$ = this.staffAvailabilitySubject.asObservable();

  staffAvailabilityChanged(staffAvailability: AssignmentAvailabilityStatus) {
    this.store.dispatch(new ToggleFilterLoading(true));
    this.staffAvailabilitySubject.next(staffAvailability);
    this.store.dispatch(
      new SetTimelineAssignmentModalFilters({
        staffAvailability,
      }),
    );
  }

  qualifiedStaffChanged(showOnlyQualifiedStaff: boolean) {
    this.store.dispatch(new ToggleFilterLoading(true));
    this.showOnlyQualifiedStaffSubject.next(showOnlyQualifiedStaff);
    this.store.dispatch(
      new SetTimelineAssignmentModalFilters({
        showOnlyQualifiedStaff,
      }),
    );
  }

  qualifiedWorkingTimeStaffChanged(showOnlyQualifiedWorkingTimeStaff: boolean) {
    this.store.dispatch(new ToggleFilterLoading(true));
    this.showOnlyQualifiedWorkingTimeStaffSubject.next(
      showOnlyQualifiedWorkingTimeStaff,
    );

    this.store.dispatch(
      new SetTimelineAssignmentModalFilters({
        showOnlyQualifiedWorkingTimeStaff,
      }),
    );
  }
}
